import script from "./AchievementsMain.vue?vue&type=script&setup=true&lang=js"
export * from "./AchievementsMain.vue?vue&type=script&setup=true&lang=js"

import "./AchievementsMain.vue?vue&type=style&index=0&id=65fd74e6&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65fd74e6"]])

export default __exports__